/*
 * Copyright © Digibaneh. All rights reserved.
 * @author: Amin Latifkar <amin.latifkar@gmail.com>
 */
interface ValidationValue {
    value: string;
}

const Rules = {
    foobar: function (value: ValidationValue) {
        return ['foo', 'bar'].includes(value.value)
    },
    nationalCode: function (value: ValidationValue) {
        const nationalCode = value.value;
        if(nationalCode.length === 0){
            return true;
        }
        if ((/^\d{10}$/.test(nationalCode))) {
            if (nationalCode == '0000000000' ||
                nationalCode == '1111111111' ||
                nationalCode == '2222222222' ||
                nationalCode == '3333333333' ||
                nationalCode == '4444444444' ||
                nationalCode == '5555555555' ||
                nationalCode == '6666666666' ||
                nationalCode == '7777777777' ||
                nationalCode == '8888888888' ||
                nationalCode == '9999999999' ||
                nationalCode == '0123456789') {
                return false;
            }
            const c = parseInt(nationalCode.charAt(9));
            const n = parseInt(nationalCode.charAt(0)) * 10 +
                parseInt(nationalCode.charAt(1)) * 9 +
                parseInt(nationalCode.charAt(2)) * 8 +
                parseInt(nationalCode.charAt(3)) * 7 +
                parseInt(nationalCode.charAt(4)) * 6 +
                parseInt(nationalCode.charAt(5)) * 5 +
                parseInt(nationalCode.charAt(6)) * 4 +
                parseInt(nationalCode.charAt(7)) * 3 +
                parseInt(nationalCode.charAt(8)) * 2;
            const r = n % 11;
            if ((r == 0 && r == c) || (r == 1 && c == 1) || (r > 1 && c == 11 - r)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },
    onlyPersian: function (value: ValidationValue) {
        if(value.value.length > 0) {
            if (!(/^[^\w\d]+$/.test(value.value))) {
                return false;
            }
        }
        return true;
    },
    postCode: function (value: ValidationValue) {
        if(value.value.length > 0) {
            if (!(/^\d{10}$/.test(value.value))) {
                return false;
            }
        }
        return true;
    },
    mobile: function (value: ValidationValue) {
        if(value.value.length > 0) {
            if (!(/^09\d{9}$/.test(value.value))) {
                return false;
            }
        }
        return true;
    },
    landLine: function (value: ValidationValue) {
        if(value.value.length > 0) {
            if (!(/^0[1-8]\d{1}-\d{8}$/.test(value.value))) {
                return false;
            }
        }
        return true;
    }
}

export default Rules;